import { WizardStep } from "@/shared/Wizard/models/WizardStep";
import { WizardStepContent } from "@/shared/Wizard/models/WizardStepContent";
import { AnalysisWizardSharedModel } from "./AnaylsisWizardSharedModel";
import { AnalysisWizardStepType } from "./AnyalsisWizardStepType";
import { Component } from "vue";



export class AnalysisWizardStep extends WizardStep<
    AnalysisWizardSharedModel,
    (typeof AnalysisWizardStepType)[keyof typeof AnalysisWizardStepType]> {

    constructor(public title: string,
        public icon: any,
        public stepContent: WizardStepContent<AnalysisWizardSharedModel> | Array<WizardStepContent<AnalysisWizardSharedModel>>,
        public type: (typeof AnalysisWizardStepType)[keyof typeof AnalysisWizardStepType],
        public statusComponent?: Component
    ) {
        super();
    }

}